module.exports = __webpack_public_path__ + "static/media/footerimg1.9dc8cbe7.PNG";